import i18n from 'i18next';
import * as yup from 'yup';

const validations = yup.object().shape({
  password: yup.string().required(() => i18n.t('security-login.validations.passwordRequired'))
});
export default validations;
